import React from 'react';
import { Link } from 'react-router-dom';

import { normalizeUri } from 'pages/Search/utils';

import useStyles from './styles';

interface Props {
    to: string;
    label: string;
    active?: boolean;
    className?: string;
}

const RedirectLink: React.FC<Props> = ({ to, label, active = true, className }) => {
    const { classes, cx } = useStyles();

    return active ? (
        <Link to={normalizeUri(to, { double: true })} className={cx(classes.link, className)}>
            {label}
        </Link>
    ) : (
        label
    );
};

export default RedirectLink;
